import React, { useEffect, useState, useRef } from 'react'
import { ParamType, StructureType } from '../../../pages/ClientPanel/Certificates/CreateParam'
import ModalTest from '../../BaseModal'
import ApiService from '../../../services/ApiService'
import { HiddenCheckbox, StyledCheckbox } from '../../FieldManager/style'
import { BottomDiv, ButtonContainer, Button, CloseDiv, ContainerOfModal, Header, HeaderTitle } from '../../styles/modal-style'
import { ColumnLI, ColumnsList, ContainerOfColumns, ColumnInfoDiv, ColumnName, SelectDiv, Dropdown, DropdownItem, DropdownContainer } from './style'
import { ChevronDown, X } from 'lucide-react'

interface PropsType {
  onClose: () => void
  param: ParamType
  setParam: React.Dispatch<React.SetStateAction<ParamType>>
  clickedStructure: number
}

export interface ColumnType {
  id: number
  name: string
  structureId: number
  min?: number
  max?: number
  unitOfMeasurement?: {id:number, name:string}[]
  unitUsed?: {id:number, name:string}
  possibleUnits?: {id:number, name:string}[]
}

const EditStructureModal:React.FC<PropsType> = ({ onClose, param, setParam, clickedStructure }) => {
  const [ previewStructure, setPreviewStructure ] = useState<StructureType>(param.structures.find((item) => item.id === clickedStructure)!)
  const [ columns, setColumns ] = useState<ColumnType[]>([])
  const [ dropdown, setDropdown ] = useState<number | null>(null)
  const dropdownRefs = useRef<Map<number, HTMLDivElement>>(new Map())

  useEffect(() => {
    ApiService.structure.getColumns(clickedStructure)
      .then((response: any) => {
        if(response.data) setColumns(response.data)
      })
      .catch((error: any) => {
        console.error(error)
      })
  }, [])


  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdown !== null) {
        const currentDropdownRef = dropdownRefs.current.get(dropdown)
        if (currentDropdownRef && !currentDropdownRef.contains(event.target as Node)) {
          setDropdown(null)
        }
      }
    }

    if (dropdown !== null) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropdown])

  const handleChangeUnit = (id: number, column: ColumnType) => {
    setPreviewStructure((prev) => {
      return {
        ...prev,
        columns: prev.columns.map((col) => {
          if(col.id !== column.id) return col
          return {
            ...col,
            unitUsed: {
              id: id,
              name: column.unitOfMeasurement?.find(unit => unit.id === id)?.name || ''
            }
          }
        })
      }
    })
    setDropdown(null)
  }

  const verifyDisabled = (column: ColumnType) => {
    return previewStructure.columns.some(col => col.id === column.id) ? false : true
  }
  
  const handleSelectColumn = (column:ColumnType) => {
    setPreviewStructure(prev => {
      const exists = prev.columns.some(col => col.id === column.id)
      const newColumns = exists ? prev.columns.filter(col => col.id !== column.id) : [...prev.columns, {
        ...column,
        ...(column.unitOfMeasurement?.[0] && {
          unitUsed: {
            id: column.unitOfMeasurement?.[0].id,
            name: column.unitOfMeasurement?.[0].name
          }
        })
      }]

      return {
        ...prev,
        columns: newColumns,
      }
    })
  }

  const handleSave = () => {
    // if(previewStructure.columns.some(col => !col.unitUsed?.id)) {
    //   return
    // }
    setParam(prev => ({
      ...prev,
      structures: prev.structures.map(item => item.id === clickedStructure ? {
        ...previewStructure,
        columns: previewStructure.columns.map(c => {
          const {unitOfMeasurement, ...rest} = c
          return rest
        })
      } : item)
    }))
    onClose()
  }
  
  return (
    <ModalTest>
      <ContainerOfModal>
        <Header>
          <HeaderTitle>{previewStructure.name}</HeaderTitle>
          <CloseDiv onClick={onClose}> <X size={20} /> </CloseDiv>
        </Header>
        <ContainerOfColumns>
          <ColumnsList>
            {columns.map((column) => (
              <>
              <ColumnLI key={column.id}>
                <HiddenCheckbox
                  checked={previewStructure.columns.some(col => col.id === column.id) || false}
                  onClick={() => handleSelectColumn(column)}
                />
                <StyledCheckbox checked={previewStructure.columns.some(col => col.id === column.id) || false} onClick={() => handleSelectColumn(column)} />
                <ColumnInfoDiv onClick={() => handleSelectColumn(column)}>
                  <ColumnName>{column.name}</ColumnName>
                </ColumnInfoDiv>
                <DropdownContainer ref={(el) => {
                  if (el) {
                    dropdownRefs.current.set(column.id, el)
                  } else {
                    dropdownRefs.current.delete(column.id)
                  }
                }}>
                  <SelectDiv onClick={() => !verifyDisabled(column) && setDropdown(column.id)} disabled={verifyDisabled(column)}>
                    {previewStructure.columns.find(col => col.id === column.id)?.unitUsed?.name || '-'}
                    <ChevronDown size={12} style={{position: 'absolute', right: '0'}} />
                  </SelectDiv>
                  {dropdown === column.id && (
                    <Dropdown>
                      {column.unitOfMeasurement?.map((item: {id:number, name:string}) => (
                        <DropdownItem key={item.id} onClick={() => handleChangeUnit(item.id, column)}>{item.name}</DropdownItem>
                      ))}
                    </Dropdown>
                  )}
                </DropdownContainer>
              </ColumnLI>
              </>
            ))}
          </ColumnsList>
        </ContainerOfColumns>
        <BottomDiv>
          <ButtonContainer>
            <Button onClick={onClose} className='cancel'>Cancelar</Button>
            <Button onClick={handleSave}>Salvar estrutura</Button>
            {/* <Button disabled={previewStructure.columns.some(col => !col.unitUsed?.id)} onClick={handleSave}>Salvar estrutura</Button> */}
          </ButtonContainer>
        </BottomDiv>
      </ContainerOfModal>
    </ModalTest>
  )
}

export default EditStructureModal
